import axios from "axios";
import { t, lang } from "@/i18n";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true, headers: { "X-Lang": lang } });
const NO_REFRESH = ["/auth/login", "/auth/register", "/auth/refresh", "/auth/forgot-password", "/auth/reset-password"];
let refreshing = null;

export const refreshSession = () => {
  refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
  return refreshing;
};

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const qd = error.response?.status === 402 && error.response.data?.detail;
    if (qd?.code === "quota_exceeded") window.dispatchEvent(new CustomEvent("quota:exceeded", { detail: qd }));
    const orig = error.config;
    if (error.response?.status === 401 && orig && !orig._retry && !NO_REFRESH.some((p) => orig.url.includes(p))) {
      orig._retry = true;
      try {
        await refreshSession();
        return api(orig);
      } catch (e) {
        window.dispatchEvent(new Event("auth:logout"));
      }
    }
    return Promise.reject(error);
  }
);

export function errMsg(e, fallback = t("api.une_erreur_est_survenue_reessayez")) {
  const d = e?.response?.data?.detail;
  if (d == null) return fallback;
  if (typeof d === "string") return d;
  if (d.code === "quota_exceeded") return t("quota.title");
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export default api;
